import { render } from "./ProductDetailView.vue?vue&type=template&id=73c98fa6&scoped=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailView.vue?vue&type=script&lang=js"

import "./ProductDetailView.vue?vue&type=style&index=0&id=73c98fa6&lang=scss&scoped=true"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c98fa6"]])

export default __exports__